import { BasePage } from "@Tenants/Fd/Site/BasePage";
import { BaseBlog } from "@Base/Blog/Blog";

class Blog extends BaseBlog
{
	constructor()
	{
		super();
	}

	public async Initialize(): Promise<void>
	{
		super.Initialize();
	};
}

export class BlogPage extends BasePage
{
	public Blog: Blog;

	constructor()
	{
		super();
		this.Initialize();
	}

	public async Initialize(): Promise<void>
	{
		super.Initialize();
		this.Blog = new Blog();
	};
}

const blog = new BlogPage();